import { useEffect } from "react";
import { MessageCircle, BellRing } from "lucide-react";
import { api } from "../lib/api";
import { fdate, money, useLoad } from "../lib/util";
import { waLink } from "../lib/whatsapp";
import { Badge, Btn, Card } from "../components/kit";
import { chargeText } from "./PaymentsTab";

const iso = (d) => d.toLocaleDateString("sv-SE");

export default function DueSoon() {
  const [data, reload] = useLoad(async () => {
    const [p, s] = await Promise.all([api.get("/admin/payments"), api.get("/admin/schools")]);
    return { pays: p.data, schools: s.data };
  }, []);
  useEffect(() => {
    window.addEventListener("mapia:admin", reload);
    return () => window.removeEventListener("mapia:admin", reload);
  }, [reload]);
  if (!data) return null;
  const today = new Date();
  const from = iso(today);
  const to = iso(new Date(today.getTime() + 3 * 86400000));
  const due = data.pays.filter((p) => ["pendente", "atrasado"].includes(p.status) && p.due_date >= from && p.due_date <= to).sort((a, b) => a.due_date.localeCompare(b.due_date));
  const daysLeft = (d) => Math.round((new Date(`${d}T12:00:00`) - new Date(`${from}T12:00:00`)) / 86400000);
  return (
    <Card className="mb-6" data-testid="due-soon-card">
      <h3 className="font-heading font-bold text-[#0B192C] flex items-center gap-2 mb-3"><BellRing className="w-5 h-5 text-[#FF6500]" />Cobranças que vencem nos próximos 3 dias</h3>
      {!due.length ? (
        <p className="text-sm text-slate-500" data-testid="due-soon-empty">Nenhuma cobrança em aberto vencendo até {fdate(to)}.</p>
      ) : (
        <div className="divide-y">
          {due.map((p) => {
            const s = data.schools.find((x) => x.id === p.school_id);
            const wa = s && waLink(s.whatsapp, chargeText(p, s));
            const dl = daysLeft(p.due_date);
            return (
              <div key={p.id} className="flex flex-wrap items-center justify-between gap-3 py-2.5" data-testid={`due-soon-${p.id}`}>
                <div className="text-sm">
                  <b>{s?.name || "—"}</b> · {money(p.amount)} · {p.method === "pix" ? "Pix" : "Boleto"}
                  <div className="text-xs text-slate-500">Vence em {fdate(p.due_date)} <Badge tone={dl === 0 ? "red" : "amber"}>{dl === 0 ? "hoje" : `em ${dl} dia(s)`}</Badge></div>
                </div>
                {wa ? <a href={wa} target="_blank" rel="noreferrer"><Btn data-testid={`due-soon-whatsapp-${p.id}`}><MessageCircle className="w-4 h-4" />Cobrar no WhatsApp</Btn></a> : <Badge tone="amber">Escola sem WhatsApp</Badge>}
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
